import { render, staticRenderFns } from "./UserPointsButton.vue?vue&type=template&id=28258840&"
import script from "./UserPointsButton.vue?vue&type=script&lang=js&"
export * from "./UserPointsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports